// YYYY-MM-dd
export type ISODate = string;

// YYYY-MM-ddTHH:mm:ss.SSSZ
export type ISODateTime = string;

// YYYY-MM-ddTHH:mm:ss
export type StringDateTime = string;

// HH:mm:ss
export type StringTime = string;

/**
 * Tenor from tradecapture can be:
 * - CalendarTenor
 * - calculated tenor (e.g. 1D, 2D...)
 */
export type Tenor = string;

const NAMED_CALENDAR_TENORS = ['TOD', 'TOM', 'ON', 'SP', 'TN', 'SN', 'IMM1', 'IMM2', 'BMF'] as const;

const NUMERIC_CALENDAR_TENORS = [
  '1W',
  '2W',
  '3W',
  '1M',
  '2M',
  '3M',
  '6M',
  '9M',
  '12M',
  '18M',
  '2Y',
  '3Y',
  '4Y',
  '5Y',
  '10Y',
] as const;

export { NAMED_CALENDAR_TENORS };

export const ALL_CALENDAR_TENORS = [...NAMED_CALENDAR_TENORS, ...NUMERIC_CALENDAR_TENORS] as const;

export type CalendarTenor = (typeof ALL_CALENDAR_TENORS)[number];

export type DurationInMilliseconds = number;
export type DurationInSeconds = number;
export type DurationInMinutes = number;
